import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
        <FAQSection />
        <CardsSection />
        <IndexSection />
        <ContactSection />
        <CarouselSection />
        <AppSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}